export default __webpack_public_path__ + "static/media/Cossi.6c094192.png";